import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { firestore } from './../../firebase/firebase';
import { Notification } from './../../models/Notification';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';

interface GetNotificationsActionType {
  type: typeof GET_NOTIFICATIONS;
  payload: {
    notifications: Notification[];
  };
}

export type NotificationActionTypes = GetNotificationsActionType;

const getNotificationsAction = (
  notifications: Notification[]
): GetNotificationsActionType => {
  return {
    type: GET_NOTIFICATIONS,
    payload: { notifications },
  };
};

export const getNotifications = () => {
  return (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    return firestore
      .collection('notifications')
      .orderBy('timestamp', 'desc')
      .onSnapshot((querySnaphot) => {
        const notifications: Notification[] = [];
        querySnaphot.forEach((doc) => {
          const notification = new Notification(
            doc.id,
            doc.data().title,
            doc.data().message,
            doc.data().timestamp?.toDate().toString()
          );
          notifications.push(notification);
        });

        dispatch(getNotificationsAction(notifications));
      });
  };
};

// const notificationConverter: firebase.firestore.FirestoreDataConverter<Notification> = {
//   toFirestore(notification: Notification): firebase.firestore.DocumentData {
//     return {
//       id: notification.id,
//       message: notification.message,
//       author: notification.timestamp,
//     };
//   },
//   fromFirestore(
//     snapshot: firebase.firestore.QueryDocumentSnapshot,
//     options: firebase.firestore.SnapshotOptions
//   ): Notification {
//     const data = snapshot.data(options)!;
//     console.log(data);

//     return new Notification(
//       data.id,
//       data.message,
//       data.timestamp.toDate().toString()
//     );
//   },
// };
